import React from "react";
const MessageBox = ({message,type='success'})=>{
    return (
        <div className={`my-message-box ${type}`}>
            <p>{message}</p>
        </div>
    )
}
export default MessageBox;